import React, { useMemo } from 'react';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { useParams } from 'react-router-dom';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import useDetailFetch from '../../../../hooks/useDetailFetch';

const SingleAnalyticsDataDetails = () => {
  const { analyticsId } = useParams();
  const decodedId = analyticsId ? atob(analyticsId) : analyticsId;
  const id = decodedId.replace(/\D/g, '');

  const url = id ? `${API_DOMAIN}${API_ROUTES['analyticsData']}${id}/` : null;
  const { data: details, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!details) return null;
    const excluded = ['id', 'updated_at', 'created_at'];
    return Object.keys(details)
      .filter(c => !excluded.includes(c))
      .map(c => ({ label: c.charAt(0).toUpperCase() + c.slice(1), field: c }));
  }, [details]);

  return (
    <SingleItemDetailTemplate
      details={details}
      columns={columns}
      loading={loading}
      entityName="Analytics Data"
      listPath="/reporting/analytics/list"
    />
  );
};

export default SingleAnalyticsDataDetails;